import * as redux from 'redux';
import thunk from 'redux-thunk';
import { routerReducer } from 'react-router-redux';
import * as reducers from './reducers';
import { reducer as formReducer } from 'redux-form';

export const configure = (initialState = {}) => {
  // Also see end of App.js for additional props being mapped
  let storeData = {
    routing: routerReducer,
    userList: reducers.userListReducer,
    roleActionList: reducers.roleActionListReducer,
    kvsList: reducers.kvsListReducer,
    kvsHistoryList: reducers.kvsHistoryListReducer,
    loginAttemptList: reducers.loginAttemptListReducer,
    appInfoList: reducers.appInfoListReducer,
    logURLList: reducers.logURLListReducer,
    hostInfoList: reducers.hostInfoListReducer,
    hostInfoListStatus: reducers.hostInfoListStatusReducer,
    selectedHostInfoIdList: reducers.selectedHostInfoIdListReducer,
    selectedKVS: reducers.selectedKVSReducer,
    auth: reducers.authReducer,
    form: formReducer,
    xpressTemplateList: reducers.xpressTemplateListReducer,
    g2ConvertHistoryList: reducers.g2ConvertHistoryListReducer,
    org2OrgHistoryList: reducers.org2OrgHistoryListReducer,
    queueActionData: reducers.queueActionDataReducer,
    queueActionLog: reducers.queueActionDataReducer,
    lastAccessedKiosk: reducers.lastAccessedKioskReducer,
  };

  let reducer = redux.combineReducers(storeData);

  return redux.createStore(
    reducer,
    initialState,
    redux.compose(
      redux.applyMiddleware(thunk),
      window.devToolsExtension ? window.devToolsExtension() : (f) => f
    )
  );
};



// WEBPACK FOOTER //
// ./src/redux/configureStore.js